import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import {betterAuthErrorSchema} from './better-auth-response.schemas';

const resetPasswordResponseSchema = z.object({
  data: z.unknown().nullish(),
  error: betterAuthErrorSchema.nullish(),
});

export type BetterAuthResetPasswordResponse = z.output<typeof resetPasswordResponseSchema>;

export class BetterAuthResetPasswordResponseValidator
  implements Validator<BetterAuthResetPasswordResponse>
{
  readonly standardSchema = resetPasswordResponseSchema;

  validate(value: unknown): Result<BetterAuthResetPasswordResponse, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Unexpected reset-password response shape.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
